<mat-form-field>
  <mat-label>所属组织</mat-label>
  <mat-select [value]="orgCode" (selectionChange)="onOrgSelectionChange($event)">
    <mat-option *ngFor="let org of orgs|async" [value]="org.stkOrganizationCode">
      {{org.stkOrganizationName}}
    </mat-option>
  </mat-select>
</mat-form-field>